
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import {
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grow,
  Link,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Typography,
  Box
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

function AppBarSubOption({title, options}){
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const navigate = useNavigate();

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  return (
    <>
    <MenuItem
      onClick={handleToggle}
      ref={anchorRef}
    >
      <Box display="flex" justifyContent="space-between" width="100%">
        {title}
        <KeyboardArrowRight />
        {/* {open ? <KeyboardArrowLeft /> : <KeyboardArrowRight />} */}
    </Box>
    </MenuItem>
    <Popper
      sx={{
        zIndex: 1,
      }}
      open={open}
      anchorEl={anchorRef.current}
      role={undefined}
      transition
      disablePortal
      placement="right-start"
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin: "left",
          }}
        >
          <Paper>
            <ClickAwayListener onClickAway={handleClose}>
              <MenuList id="split-button-menu" autoFocusItem>
                {options.map((option, index) => (
                  <Link
                    textAlign="center"
                    href={option.link}
                    className="UserMenu"
                    key={option + index}
                  >
                    <MenuItem>
                      {option.name}
                    </MenuItem>
                  </Link>
                ))}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
    </>
  )
}


export { AppBarSubOption };